import { css } from "@emotion/css";
import { AriaRadioGroupProps, useRadioGroup } from "react-aria";
import { useRadioGroupState } from "react-stately";

import { AccessibilityWarnings } from "../../../../components/inputs/AccessibilityWarnings";
import { FieldErrorsProps } from "../../../../components/inputs/_assets/input-wrapper/FieldErrors";
import { FormFeedback } from "../../../../components/inputs/_assets/input-wrapper/FormFeedback";
import { FormLabel } from "../../../../components/inputs/_assets/input-wrapper/FormLabel";
import { FormText } from "../../../../components/inputs/_assets/input-wrapper/FormText";
import {
  InputWrapper,
  InputWrapperProps,
} from "../../../../components/inputs/_assets/input-wrapper/InputWrapper";
import { RadioContext } from "../context";

export interface RadioGroupProps
  extends AriaRadioGroupProps,
    Omit<InputWrapperProps, "children"> {
  direction?: "column" | "row";
  children: React.ReactNode;
  errors?: FieldErrorsProps["children"];
  testID?: string;
}

/**
 * @deprecated see RadioGroupRAC
 */
export function RadioGroup(props: RadioGroupProps) {
  const {
    children,
    label,
    description,
    errors,
    span = "auto",
    testID = "radio-group",
    direction = "column",
  } = props;
  const state = useRadioGroupState(props);
  const { radioGroupProps, labelProps, descriptionProps, errorMessageProps } =
    useRadioGroup(props, state);

  return (
    <InputWrapper span={span}>
      <div {...radioGroupProps} data-testid={testID}>
        <FormLabel {...labelProps} isRequired={props.isRequired}>
          {label}
        </FormLabel>
        <RadioContext.Provider value={state}>
          <div
            className={css(styles.container, {
              flexDirection: direction,
              marginTop: label ? "var(--space-2)" : undefined,
              gap: direction === "column" ? "var(--space-2)" : "var(--space-6)",
            })}
          >
            {children}
          </div>
        </RadioContext.Provider>
        <FormText {...descriptionProps}>{description}</FormText>
        <FormFeedback {...errorMessageProps}>{errors}</FormFeedback>

        <AccessibilityWarnings labelProps={props} />
      </div>
    </InputWrapper>
  );
}

const styles = {
  container: css({
    display: "flex",
  }),
  title: css({
    paddingBottom: "var(--space-2)",
  }),
};
